import { Layout, Typography, Button } from "antd";
import { useAuth } from "react-oidc-context";

const Content = Layout;
const Title = Typography;
export default function SinglePage() {
  const auth = useAuth();
  return (
    <>
      <div className="layout-default ant-layout layout-sign-up">
        <Content className="p-0">
          <div className="sign-up-header">
            <div className="content">
              <Title>Go to Single Sign-On</Title>
              <a
                type="primary"
                onClick={() =>
                  auth.signinRedirect({
                    redirect_uri: window.location.origin,
                  })
                }
              >
                <Button type="primary">Go</Button>
              </a>
            </div>
          </div>
        </Content>
      </div>
    </>
  );
}
